<template>
    <v-list-item title="انتخاب همه" @click="$emit('clicked')">
        <template v-slot:prepend>
            <v-checkbox-btn
                :indeterminate="items.length < all.length && items.length !== 0"
                :model-value="items.length !== 0"
            ></v-checkbox-btn>
        </template>
    </v-list-item>
    <v-divider class="mt-2"></v-divider>
</template>
<script>
export default {
    props:{
        items:{
            type:Array
        },
        all:{
            type:Array
        }
    }
}
</script>
